import { render, staticRenderFns } from "./ChangeEmailForm.vue?vue&type=template&id=0fff87ec&"
import script from "./ChangeEmailForm.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports